import React from 'react';
import { NavLink } from "react-router-dom";
import { deleteAuthorizationKey } from "../../utils/api";

export const Error = ({ message }: any): JSX.Element => {

  const logOut = () => {
    deleteAuthorizationKey(["token"]);
  }

  return (
    <span className="text-danger" onClick={logOut}>{message}{typeof (message) == "string" && message.toLowerCase().indexOf("token") >=0 && <NavLink to="/login" className="badge badge-danger">Click here to update the token</NavLink>}</span>
  )
}
